"use client";

import { PlainMessage } from "@bufbuild/protobuf";
import {
  CustomSeats,
  Section,
} from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { IExtendedSeat } from "@seatmap.pro/renderer";
import { useTranslations } from "~/hooks/useTranslations";

interface Props {
  seat: IExtendedSeat | null;
  section?: PlainMessage<Section>;
}

export function SeatInfoTooltip({ seat, section }: Props) {
  const t = useTranslations();

  const customSeat = (
    section?.customSeats as PlainMessage<CustomSeats>[] | undefined
  )?.find((c) => c.seatIds.includes(seat?.id ?? Infinity));

  return (
    customSeat?.prices ? customSeat.prices.length : section?.prices?.length
  ) ? (
    <>
      <span>
        {t.select_price.section} {section?.name}
      </span>

      <span>
        {t.select_price.row} {seat?.rowNumber}
      </span>
      <span>
        {t.select_price.seat} {seat?.seatName}
      </span>
    </>
  ) : (
    <span>{t.select_price.section_no_prices}</span>
  );
}
